/**
 * Константы для projectStorage (Block 5 / C-блок +4, фидбэк Janni).
 *
 * DEFAULT_PROJECT_KEY — localStorage-ключ для «последнего выбранного проекта».
 * Используется в FilesUploadPage, FilesResultsPage, HeaderPanel (generation),
 * SearchHeaderPanel — чтобы picker'ы знали, из какого проекта показывать dataset'ы.
 *
 * Не дублировать magic-строки в разных файлах.
 *
 * С Block 5 / B+C v5 (фидбэк Janni «не могу выбрать проект»): чтение/запись
 * идёт через useProjectStore (Zustand), а localStorage — только persistence-слой
 * стора. Импортируйте useProjectStore в компонентах, а НЕ лазайте в localStorage
 * напрямую — иначе смена проекта в Header не увидится в других страницах.
 */
export const DEFAULT_PROJECT_KEY = 'cs_default_project_id';
